import ImageTextViacompra from "./ImageTextViacompra";

export default ImageTextViacompra;
